import React, { memo } from 'react'

import HomeContainer from '../../../../containers/HomeContainer'

const HomeContainerWrapper = (props) => {
  return <HomeContainer {...props} />
}

export default memo(HomeContainerWrapper)
